@if (settingsS.isOpen()) {
    <app-modal-bg (modalClick)="settingsS.close()">
        <tw-modal-card
            [title]="T.settings.title | translate"
            [subtitle]="T.settings.subtitle | translate"
            width="md"
            (close)="settingsS.close()">
            <div body class="flex flex-col gap-6">
                <!-- Personalization -->
                <section class="flex flex-col gap-4">
                    <span class="tw-section-label">{{ T.settings.personalization | translate }}</span>

                    <div class="flex flex-col gap-1.5">
                        <label class="tw-form-label" for="ac-default-agent">
                            {{ T.settings.defaultAgent | translate }}
                        </label>
                        <select
                            id="ac-default-agent"
                            class="tw-input-text"
                            (change)="setDefaultAgent($any($event.target).value)">
                            <option value="">{{ T.settings.noDefault | translate }}</option>
                            @for (agent of agents(); track agent.id) {
                                <option [value]="agent.id" [selected]="prefs().defaultAgentId === agent.id">
                                    {{ agent.name }}
                                </option>
                            }
                        </select>
                        <p class="text-[12px] text-zinc-500">{{ T.settings.defaultAgentHint | translate }}</p>
                    </div>

                    <div class="flex flex-col gap-1.5">
                        <label class="tw-form-label" for="ac-welcome">
                            {{ T.settings.welcome | translate }}
                        </label>
                        <textarea
                            id="ac-welcome"
                            class="tw-textarea"
                            rows="2"
                            [value]="prefs().welcomeMessage"
                            [placeholder]="T.settings.welcomePlaceholder | translate"
                            (input)="setWelcome($any($event.target).value)"></textarea>
                    </div>

                    <div class="flex flex-col gap-1.5">
                        <label class="tw-form-label" for="ac-launcher">
                            {{ T.settings.launcherLabel | translate }}
                        </label>
                        <input
                            id="ac-launcher"
                            class="tw-input-text"
                            [value]="prefs().launcherLabel"
                            [placeholder]="T.brand | translate"
                            (input)="setLauncherLabel($any($event.target).value)" />
                    </div>
                </section>

                <div class="tw-divider"></div>

                <!-- Widget -->
                <section class="flex flex-col gap-4">
                    <div class="flex flex-col gap-1">
                        <span class="tw-section-label">{{ T.settings.widget | translate }}</span>
                        <p class="text-[12px] text-zinc-500">{{ T.settings.widgetHint | translate }}</p>
                    </div>

                    <div class="flex flex-col gap-1.5">
                        <label class="tw-form-label" for="ac-widget-url">
                            {{ T.settings.widgetUrl | translate }}
                        </label>
                        <div class="flex items-center gap-2">
                            <input
                                id="ac-widget-url"
                                class="tw-input-text flex-1 font-mono text-[12.5px]"
                                readonly
                                [value]="widgetUrl" />
                            <button
                                class="tw-btn-secondary shrink-0"
                                type="button"
                                (click)="copy(widgetUrl)">
                                <lucide-icon [img]="CopyIcon" [size]="15" [strokeWidth]="1.75" />
                                {{ T.settings.copy | translate }}
                            </button>
                        </div>
                    </div>

                    <div class="flex flex-col gap-1.5">
                        <label class="tw-form-label" for="ac-embed-script">
                            {{ T.settings.embedScript | translate }}
                        </label>
                        <textarea
                            id="ac-embed-script"
                            class="tw-textarea font-mono text-[12px] leading-relaxed"
                            rows="2"
                            readonly
                            [value]="embedScript"></textarea>
                        <p class="text-[12px] text-zinc-500">{{ T.settings.embedScriptHint | translate }}</p>
                        <button
                            class="tw-btn-secondary self-start"
                            type="button"
                            (click)="copy(embedScript)">
                            <lucide-icon [img]="CopyIcon" [size]="15" [strokeWidth]="1.75" />
                            {{ T.settings.copy | translate }}
                        </button>
                    </div>

                    <div class="flex flex-col gap-1.5">
                        <label class="tw-form-label" for="ac-embed">
                            {{ T.settings.embedCode | translate }}
                        </label>
                        <textarea
                            id="ac-embed"
                            class="tw-textarea font-mono text-[12px] leading-relaxed"
                            rows="3"
                            readonly
                            [value]="embedCode"></textarea>
                        <button
                            class="tw-btn-secondary self-start"
                            type="button"
                            (click)="copy(embedCode)">
                            <lucide-icon [img]="CopyIcon" [size]="15" [strokeWidth]="1.75" />
                            {{ T.settings.copy | translate }}
                        </button>
                    </div>
                </section>
            </div>

            <div footer>
                <button class="tw-btn-primary" type="button" (click)="settingsS.close()">
                    {{ T.settings.done | translate }}
                </button>
            </div>
        </tw-modal-card>
    </app-modal-bg>
}
